import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentSolicitacaoFluxoAprovarOrcamento from './ContentSolicitacaoFluxoAprovarOrcamento';

const SolicitacaoFluxoAprovarOrcamento = () => {
  return (
    <div className="d-flex flex-column min-h-screen">
      <HeaderApp />
      <ContentSolicitacaoFluxoAprovarOrcamento />
      <Bottom />
    </div>
  );
};

export default SolicitacaoFluxoAprovarOrcamento;
